function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M360.637 112.96C356.636 135.634 334.716 144.054 324.256 145.43C278.016 138.176 224.604 162.754 184.011 156.754C143.419 150.754 111.243 118.403 91.9048 107.807C72.5668 97.2108 -25.409 88.3311 7.54186 53.1813C40.4927 18.0314 92.9199 51.318 172.891 59.2134C252.863 67.1088 246.57 36.2585 282.308 25.8379C318.046 15.4174 346.462 29.9468 359.165 45.5078C371.868 61.0687 365.638 84.6176 360.637 112.96Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M195.514 9.02848e-06C155.301 -0.00792184 122.695 32.4361 122.687 72.4661C122.682 98.6144 136.826 122.739 159.7 135.595C160.398 135.996 161.23 136.099 162.006 135.879C162.777 135.665 163.431 135.157 163.827 134.465L186.287 94.9529C187.111 93.501 186.598 91.6593 185.14 90.8379C174.909 85.1181 171.274 72.2253 177.02 62.0415C182.767 51.8577 195.718 48.239 205.949 53.9591C216.179 59.6792 219.814 72.5717 214.068 82.7555C212.158 86.1406 209.349 88.9368 205.949 90.8379C204.491 91.6593 203.978 93.501 204.801 94.9529L227.2 134.465C227.595 135.159 228.25 135.67 229.022 135.885C229.286 135.961 229.56 136 229.835 136C230.359 135.999 230.873 135.864 231.328 135.607C266.352 115.937 278.725 71.7291 258.965 36.865C246.05 14.077 221.798 -0.0130203 195.514 9.02848e-06Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 294.737,
  cy: 95.2733,
  rx: 15.2625,
  ry: 15.1885,
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 121.994,
  cy: 33.8289,
  rx: 33.9938,
  ry: 33.8289,
  fill: "url(#paint2_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 283.061,
  y1: 190.29,
  x2: 136.983,
  y2: -29.3412,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#28BC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#28BC00",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 313.077,
  y1: 122.588,
  x2: 279.691,
  y2: 75.5015,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#315EFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#315EFB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 158.804,
  y1: 55.2801,
  x2: 68.6323,
  y2: 49.6697,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DADAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEEEFF",
  stopOpacity: 0
})));

function SvgOpensauce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 162,
    viewBox: "0 0 369 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpensauce);
export default __webpack_public_path__ + "static/media/opensauce.0773f97b.svg";
export { ForwardRef as ReactComponent };